/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Madein1Inputs */

const id_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat di`)
};

const ms_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibuat di`)
};

const da_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavet i`)
};

const de_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hergestellt in`)
};

const en_us2_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made in`)
};

const es_es2_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho en`)
};

const es_mx2_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho en`)
};

const fil_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginawa sa`)
};

const fr_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fabriqué en`)
};

const it_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizzato in`)
};

const hu_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Készült`)
};

const nl_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemaakt in`)
};

const no_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laget i`)
};

const pl_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stworzono w`)
};

const pt_br2_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito em`)
};

const pt_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito em`)
};

const ro_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizat în`)
};

const fi_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehty`)
};

const sv_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gjord i`)
};

const vi_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được tạo tại`)
};

const tr_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapım yeri`)
};

const cs_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyrobeno v`)
};

const bg_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Направено в`)
};

const ru_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделано в`)
};

const uk_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зроблено в`)
};

const ar_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صُنع في`)
};

const hi_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्मित`)
};

const th_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างใน`)
};

const ja_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制作`)
};

const zh_cn2_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制作于`)
};

const zh_hant1_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製作於`)
};

const ko_footer_madein1 = /** @type {(inputs: Footer_Madein1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제작`)
};

/**
* | output |
* | --- |
* | "Made in" |
*
* @param {Footer_Madein1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_madein1 = /** @type {((inputs?: Footer_Madein1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Madein1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_madein1(inputs)
	if (locale === "ms") return ms_footer_madein1(inputs)
	if (locale === "da") return da_footer_madein1(inputs)
	if (locale === "de") return de_footer_madein1(inputs)
	if (locale === "en-US") return en_us2_footer_madein1(inputs)
	if (locale === "es-ES") return es_es2_footer_madein1(inputs)
	if (locale === "es-MX") return es_mx2_footer_madein1(inputs)
	if (locale === "fil") return fil_footer_madein1(inputs)
	if (locale === "fr") return fr_footer_madein1(inputs)
	if (locale === "it") return it_footer_madein1(inputs)
	if (locale === "hu") return hu_footer_madein1(inputs)
	if (locale === "nl") return nl_footer_madein1(inputs)
	if (locale === "no") return no_footer_madein1(inputs)
	if (locale === "pl") return pl_footer_madein1(inputs)
	if (locale === "pt-BR") return pt_br2_footer_madein1(inputs)
	if (locale === "pt") return pt_footer_madein1(inputs)
	if (locale === "ro") return ro_footer_madein1(inputs)
	if (locale === "fi") return fi_footer_madein1(inputs)
	if (locale === "sv") return sv_footer_madein1(inputs)
	if (locale === "vi") return vi_footer_madein1(inputs)
	if (locale === "tr") return tr_footer_madein1(inputs)
	if (locale === "cs") return cs_footer_madein1(inputs)
	if (locale === "bg") return bg_footer_madein1(inputs)
	if (locale === "ru") return ru_footer_madein1(inputs)
	if (locale === "uk") return uk_footer_madein1(inputs)
	if (locale === "ar") return ar_footer_madein1(inputs)
	if (locale === "hi") return hi_footer_madein1(inputs)
	if (locale === "th") return th_footer_madein1(inputs)
	if (locale === "ja") return ja_footer_madein1(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_madein1(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_madein1(inputs)
	return ko_footer_madein1(inputs)
});
export { footer_madein1 as "footer.madeIn" }